/* unplugin-vue-components disabled */import script from "./jsonexcel.vue?vue&type=script&setup=true&lang=js"
export * from "./jsonexcel.vue?vue&type=script&setup=true&lang=js"

import "./jsonexcel.vue?vue&type=style&index=0&id=e7ed0b36&lang=scss"

const __exports__ = script;

export default __exports__